<div *ngIf="isSentScheduleEmail && hasScheduleSlots">
	<div class="d-flex justify-content-between align-items-center mb-3">
		<div id="time-timezone-text" class="text-danger" *ngIf="isThailandFocus">
			Timezone : {{now | date:'zzz': timezone}} (Bangkok time). The event will be conducted in physical event
		</div>
		<button class="btn btn-primary" (click)="downloadPdf()"><i class="fas fa-download mr-2"></i>Download as PDF</button>
    </div>

	<div class="schedule-table-scroll">
		<div class="schedule-table-wrapper" *ngFor="let slot of scheduleInvestorResponse.slots; let slotIndex = index; trackBy: trackByIndex">
			<table class="table meeting-schedule-table mb-4">
				<colgroup>
					<col class="col-time">
					<col class="col-room">
					<col class="col-company">
					<col class="col-presentation-file">
					<col class="col-speaker">
					<col class="col-investor">
					<col class="col-meeting-type">
				</colgroup>
				<thead>
					<tr class="slot-date-row">
						<th colspan="7">
							{{ slot.slotDate | date:'mediumDate': timezone }}
						</th>
					</tr>
					<tr class="header-row">
						<th>Date/Time</th>
						<th>Room</th>
						<th>Company</th>
						<th>Presentation File</th>
						<th>Speaker</th>
						<th>Investor</th>
						<th>Meeting Type</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let slotPeriod of slot.slotPeriods; let periodIndex = index; trackBy: trackByIndex">
						<td>
							{{ slotPeriod.startTime | date:'HH:mm': timezone }} -
							{{ slotPeriod.endTime | date:'HH:mm': timezone }}
						</td>
						<td>
							<div>{{ slotPeriod.room || '-' }}</div>
							<a *ngIf="slotPeriod.roomLink" 
								[tooltip]="slotPeriod.roomDesc" 
								id="schedule-investor-field-meeting-room-link-text-{{slotIndex}}-{{periodIndex}}"
								target="_blank" 
								[href]="slotPeriod.roomLink" 
								class="link-blue">
								Meeting Link <img src="assets/images/video.svg" alt=""></a>
						</td>
						<td>
							<span>{{ slotPeriod.presenter || '-' }}</span>
							<a *ngIf="slotPeriod.listedJumpplusId"
							   href="https://www.set.or.th/en/market/product/stock/quote/{{slotPeriod.presenterSymbol}}/company-profile/jump-plus"
							   target="_blank" rel="noopener noreferrer">
								<img src="assets/images/jumpplus.png" class="jumpplus-icon ml-1" alt="JumpPlus">
							</a>
							<span *ngIf="slotPeriod.exchangeName" class="text-muted ml-1">({{ slotPeriod.exchangeName }})</span>
						</td>
						<td class="presentation-file-cell">
							<button *ngIf="slotPeriod.presentationLink" 
								type="button"
								class="presentation-file-link"
								aria-label="Download presentation file"
								title="Download presentation file"
								(click)="downloadPresentation(slotPeriod.presentationLink)">
								<i class="fas fa-download mr-1"></i>
							</button>
						</td>
						<td>
							<div>
								<div *ngFor="let speaker of slotPeriod.participants; let speakerIndex = index; trackBy: trackByIndex" class="speaker-row">
									<div class="speaker-name">{{ speaker.name || '-' }}</div>
									<div class="speaker-job" *ngIf="speaker.jobTitle">{{ speaker.jobTitle }}</div>
								</div>
							</div>
						</td>
                        <td>
                            <ng-container *ngIf="getSortedAttendees(slotPeriod).length > 0; else noAttendee">
                                <ng-container *ngFor="let attendee of getSortedAttendees(slotPeriod); let i = index; trackBy: trackByIndex">
                                    <div class="attendee-row"
                                        *ngIf="i < 3 || isAttendeesExpanded(slotIndex + '-' + periodIndex)">
                                        <div class="attendee-name" [class.speaker-name-login]="isLoginPerson(attendee.name)">{{ attendee.name || '-' }}</div>
                                    </div>
                                </ng-container>
                                <a class="show-more-link" *ngIf="getSortedAttendees(slotPeriod).length > 3 && !isAttendeesExpanded(slotIndex + '-' + periodIndex)"
                                    (click)="toggleAttendees(slotIndex + '-' + periodIndex)">show more</a>
                                <a class="show-more-link" *ngIf="getSortedAttendees(slotPeriod).length > 3 && isAttendeesExpanded(slotIndex + '-' + periodIndex)"
                                    (click)="toggleAttendees(slotIndex + '-' + periodIndex)">show less</a>
                            </ng-container>
                            <ng-template #noAttendee></ng-template>
                        </td>
						<td>
                            <span [ngClass]="getMeetingTypeClass(slotPeriod.meetingType)">
                            {{ getMeetingType(slotPeriod) }}
                            </span>
                        </td>

					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<div *ngIf="!isSentScheduleEmail || !hasScheduleSlots">
	<div class="schedule-empty-state">
		<img src="assets/images/file.png" alt="Meeting schedule not available" class="schedule-empty-image">
		<div class="schedule-empty-line">"The information will be available during the first week of August"</div>
		<div class="schedule-empty-line">For more information, please contact</div>
		<div class="schedule-empty-line schedule-empty-email">{{ contactEmail }}</div>
	</div>
</div>